export default "__VITE_ASSET__Brtkyn7B__"